import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_CREATE_FROM_INTENT } from "./gql";

const useCreateStackFromIntent = createDefaultMutationHook(STACK_CREATE_FROM_INTENT);

export default useCreateStackFromIntent;
